import axios from "axios";
import { API_BASE } from "../config/api";
import bundledGallery from "../data/bundledGallery.json";
import bundledInsights from "../data/bundledInsights.json";

function isLocalHost() {
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1";
}

export async function fetchGalleryPhotos() {
  if (!isLocalHost()) {
    if (bundledGallery?.length > 0) {
      return { images: bundledGallery, source: "bundled" };
    }
    try {
      const staticRes = await axios.get("/static-data/gallery.json", {
        timeout: 10000,
        withCredentials: false,
      });
      const images = staticRes.data?.images || [];
      if (images.length > 0) return { images, source: "static" };
    } catch {
      /* try API next */
    }
  }

  try {
    const response = await axios.get("/api/photos", { timeout: 90000, withCredentials: false });
    const photosData = response.data;
    const images = Array.isArray(photosData)
      ? photosData
      : (photosData.images || photosData.photos || []);
    if (images.length > 0) return { images, source: "api" };
  } catch {
    /* fall through */
  }

  if (bundledGallery?.length > 0) {
    return { images: bundledGallery, source: "bundled" };
  }

  try {
    const fallback = await axios.get("/static-data/gallery.json", { timeout: 10000, withCredentials: false });
    return { images: fallback.data?.images || [], source: "static" };
  } catch {
    return { images: [], source: "none" };
  }
}

export async function fetchApprovedInsights() {
  if (!isLocalHost()) {
    if (bundledInsights?.length > 0) {
      return { insights: bundledInsights, source: "bundled" };
    }
    try {
      const staticRes = await axios.get("/static-data/insights.json", {
        timeout: 10000,
        withCredentials: false,
      });
      const insights = staticRes.data?.insights || [];
      if (insights.length > 0) return { insights, source: "static" };
    } catch {
      /* try API next */
    }
  }

  try {
    const response = await axios.get("/api/insights/approved", { timeout: 90000, withCredentials: false });
    const data = response.data;
    const insights = Array.isArray(data) ? data : (data.insights || []);
    if (insights.length > 0) return { insights, source: "api" };
  } catch {
    /* fall through */
  }

  if (bundledInsights?.length > 0) {
    return { insights: bundledInsights, source: "bundled" };
  }

  try {
    const fallback = await axios.get("/static-data/insights.json", { timeout: 10000, withCredentials: false });
    return { insights: fallback.data?.insights || [], source: "static" };
  } catch {
    return { insights: [], source: "none" };
  }
}
